module.exports = __webpack_public_path__ + "static/media/misty_isle.a5624170.png";